import * as React from 'react'
import styled from 'styled-components'
import { useFilter } from 'modules/productDetail'
import theme from 'theme'
import useTranslations from 'hooks/useTranslations'
import MoreOptionsArrow from 'theme/atoms/MoreOptionsArrow'

type Props = {
  filterKey: 'size' | 'variant' | 'style'
  label: 'size_label' | 'style_label' | 'variant_label'
  onInteract: () => void
}

export default function Filter(props: Props) {
  const filter = useFilter(props.filterKey)
  const t = useTranslations<'templates-PDP'>()
  if (filter.data.options.length === 0) return null

  const clickable = filter.data.options.length > 1

  return (
    <Wrapper
      className="Filter"
      data-cy-collection="Filter"
      onClick={clickable ? props.onInteract : undefined}
      as={clickable ? 'button' : undefined}
      title={t.asText(false, 'to_filter_drawer_title')}
      id={`filter-id-${props.filterKey}`}
    >
      <div className="label">{t(props.label)}</div>
      <div className="value">{filter.data.value}</div>
      {clickable && (
        <MoreOptionsArrow
          // since wrapper is button the child cannot be a button
          asDiv
          aria-label={t.asText(false, 'BFSG_show_more_options')}
          data-cy-state="multiple-filter-options"
          lengthLabel={t(`${props.label}_number`, {
            pieces: filter.data.options.length.toString()
          })}
        />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  padding: ${theme.spacing('s')} 0;
  align-items: center;
  border-top: 1px solid ${theme.colors.shade.b2};
  &:last-child {
    border-bottom: 1px solid ${theme.colors.shade.b2};
  }

  > .label {
    min-width: 5rem;
    ${theme.ty('rc-base')}
  }

  > .value {
    flex: 1;
    ${theme.ty('rc-base')}
    color: ${theme.colors.b0};
    margin-left: ${theme.spacing('s')};
  }
`
